module.exports = __webpack_public_path__ + "img/b3-4.0564482.png";